export default __webpack_public_path__ + "media/images/coworkr/favicons/icon_final-4a9b58b5a02dc6a7a7ba84bc6ee9ae06.png";